import { RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { TooltipModule } from 'ngx-bootstrap/tooltip';

import { Ng2TableModule } from '../../shared/components/ng-table/ng-table-module';
import { SharedPipesModule } from '../../shared/pipes/shared-pipes.module';
import { SharedComponentsModule } from '../../shared/components/shared-components.module';

import { CustomerPageComponent } from './customer-page.component';
import { CustomerPageUpdatesComponent } from './customer-page-updates/customer-page-updates.component';
import { CustomerPageRequestsComponent } from './customer-page-requests/customer-page-requests.component';
import { CustomerPageStateComponent } from './customer-page-state/customer-page-state.component';
import { CustomerPageSelfupdateComponent } from './customer-page-selfupdate/customer-page-selfupdate.component';
import { CustomerPageSupportComponent } from './customer-page-support/customer-page-support.component';

@NgModule({
  declarations: [
    CustomerPageComponent,
    CustomerPageUpdatesComponent, 
    CustomerPageRequestsComponent, 
    CustomerPageStateComponent, 
    CustomerPageSelfupdateComponent, CustomerPageSupportComponent
  ],
  imports: [
    FormsModule,
    RouterModule,
    TabsModule,
    CommonModule,
    Ng2TableModule,
    TooltipModule.forRoot(),
    SharedPipesModule,
    SharedComponentsModule
  ],
  exports: [
    CustomerPageComponent
  ]
})
export class CustomerPageModule { }
